module.exports = __webpack_public_path__ + "static/media/icon_eth.1ebcb953.svg";